var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"width":"500","height":"200"},on:{"resolve":_vm.editHandle}},[_c('c-form',{ref:"taskForm",attrs:{"unit-width":"100%"}},[_c('c-form-item',{attrs:{"label":"设置为","required":""}},[_c('c-select',{attrs:{"name":"priority","options":_vm.prioritySelectDic}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }